import recallServices from '../../../services/provider/recall'
import Communicationdetails from '../../share/communication-view/provider/communication-details'
import ProviderActions from '../../share/communication-view/provider/provider-actions'
import WorkflowActions from '../../share/WorkflowActions'
import ProviderCommunications from '../../share/communication-view/provider/provider-conversations'
import ReportDetails from '../../share/communication-view/provider/report-details'
import ResponseModal from '../../share/ResponseModal'
import ResponseEmailModal from '../../share/ResponseEmailModal'
import RecallResponseModal from '../../share/RecallResponseModal'
import RecallResponseEmailModal from '../../share/RecallResponseEmailModal'
import ChangeHistory from '../../share/communication-view/provider/change-history'
import router from '../../../router/paths'
import organizationService from '../../../services/provider/organization'
import notiOrgService from '../../../services/notisphere/organization'
import { COMMUNICATION_TYPE } from '../../../misc/commons'
import { EMAIL_STATUS,PROVIDER_EVENTLISTING_STATUS, RECALL_CLASSIFICATIONS, RECALL_STATUS } from '../../../misc/commons'
import _ from 'lodash'
export default {
    props: {
        id: {type: String, default: null},
        communicationId: {type: String, default: null},
        providerCommunicationId: {type: String, default: null},
        recallSiteCount: {type: Number, default: null},
        coveredStatus: {type: String,default: 'null'},
        communicationType: {type: String, default: null},
        switchSitesList: {type: Object, default: null}
    },
    components: {
        Communicationdetails,
        ProviderActions,
        ProviderCommunications,
        WorkflowActions,
        ChangeHistory,
        ReportDetails,
        ResponseModal,
        ResponseEmailModal,
        RecallResponseModal,
        RecallResponseEmailModal
    },
    data () {
        return {
            item: null,
            tabDetails: false,
            tabActions: false,
            tabCommunications: false,
            tabReports: false,
            tabHistory: false,
            tabWorkflow: false,
            isProviderCreatedRecall: false,
            iscustomisedcontent: false,
            respModalKey: 0,
            responseEmailKey: 0,
            responseDetails: null,
            responseFormData: null,
            type: null,
            disabledDelegate: false,
            completedRecall: false,
            SupplierContactlst: [],
            autonotifychecked: false,
            SupplierName: '',
            histories: [],
            updateNotificationCount: 0,
            isRedirected: false,
            is_centralized_setting_enabled: false,
            labels: {},
            emailStatus: EMAIL_STATUS,
            recall: COMMUNICATION_TYPE.RECALL,
            productdisruption: COMMUNICATION_TYPE.PRODUCTDISRUPTION,
            title: 'Recall',
            childHeader: [],
            switchSites: [],
            switchSitesTotal: 0,
            provider_eventlisting_status: _.cloneDeep(PROVIDER_EVENTLISTING_STATUS),
            recall_classification: RECALL_CLASSIFICATIONS,
            recall_status: _.cloneDeep(RECALL_STATUS),
            distributorLogo: null,
            // Toast queue management
            isToastActive: false,
            toastQueue: [],
            toastTimeout: null,
            header: [
                {
                    label: 'Complete',
                    name: 'childcopy_status_provider',
                    sort: true,
                    row_text_alignment: 'text-center',
                    column_text_alignment: 'text-center',
                    column_classes: 'customalign-2ercent',
                    row_classes: 'customalign-2percent wordbreakall',
                },
                {
                    label: 'Supplier',
                    name: 'supplier_org_name',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-10percent',
                    row_classes: 'customalign-10percent wordbreakall',
                },
                {
                    label: 'Recall ID',
                    name: 'communicationUID',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-10percent',
                    row_classes: 'customalign-10percent wordbreakall',
                },
                {
                    label: 'Name',
                    name: 'communicationName',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-10percent',
                    row_classes: 'customalign-10percent wordbreakall',
                },
                {
                    label: 'Categories',
                    name: 'categories',
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-10percent',
                    row_classes: 'customalign-10percent wordbreakall',
                    sort: true,
                },
                {
                    label: '# of Sites',
                    name: 'recallSiteName',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Response Documents',
                    name: 'response_doc',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-5percent',
                    row_classes: 'customalign-5percent wordbreakall',
                },
                {
                    label: 'Affected Product',
                    name: 'affectedProduct',
                    sort: true,
                    row_text_alignment: 'text-center',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-10percent',
                    row_classes: 'customalign-5percent wordbreakall',
                },
                {
                    label: 'Source',
                    name: 'isProviderCreated',
                    sort: true,
                    row_text_alignment: 'text-center',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-5percent',
                    row_classes: 'customalign-5percent wordbreakall',
                },

                {
                    label: 'Days Since Notified',
                    name: 'date_since_notified',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Event Status',
                    name: 'status',
                    sort: true,
                    row_text_alignment: 'text-center',
                    column_text_alignment: 'text-center',
                    column_classes: 'customalign-5percent',
                    row_classes: 'customalign-5percent wordbreakall',
                },
                {
                    label: 'Response Status',
                    name: 'responsestatus',
                    sort: true,
                    row_text_alignment: 'text-center',
                    column_text_alignment: 'text-center',
                    column_classes: 'customalign-5percent',
                    row_classes: 'customalign-5percent wordbreakall',
                },
                {
                    label: '',
                    name: 'action',
                    row_text_alignment: 'text-center',
                    column_text_alignment: 'text-center',
                },
            ],
            isDrugRecall: false
        }
    },
    created() {
        if (this.$route.query.conId && this.$route.query.conId > 0) {
            this.tabCommunications = true
        } else if(this.$route.query.tabName ==='tabDetails' ||(this.$route.query.nonAck && this.$route.query.nonAck !='')){
            this.tabDetails = true
        }
        else if(this.$route.query.tabName ==='tabHistory' ||(this.$route.query.logtype && this.$route.query.logtype !='')){
            this.tabHistory = true
        }
        else {
            this.tabDetails = true
        }
        this.is_centralized_setting_enabled = this.$store.state?.organization?.is_centralized_setting_enabled
        this.getRecallSummaryById()
        this.getAutoNotifySetting()
        this.GetRecallHistories()
        this.getResponseFormData()
    },
    beforeDestroy() {
        // Clean up toast queue and timeout on component destroy
        this.clearToastQueue()
    },
    computed: {
        isNonAcknowledged() {
            if (this.item.acknowledged_at == null && !this.item.is_provider_created_recall) {
                return true
            } else {
                return false
            }
        },
        isReopenRecallButtonDisabled() {
            return (
                (!this.isProviderCreatedRecall &&
                this.is_centralized_setting_enabled &&
                this.item.completed_at &&
                this.item.acknowledged_at)
            )
        },
    },
    methods: {
        GetRecallHistories() {
            var _this = this
            recallServices.GetRecallHistories(this.id, this.providerCommunicationId).then(resp => {
                if (!resp.error) {
                    this.histories = resp.data.d
                    if(_this.$route.query.logtype != undefined && !this.isRedirected)
                    {
                        if(_this.$route.query.logtype == 'RecallChangeLog')
                        {
                            this.isRedirected = true
                            this.updateNotificationCount = 0
                        }
                    }
                    else
                    {
                        this.updateNotificationCount = resp.data.d.filter(s => s.updatenotification == true).length
                    }
                }
            })
        },
        fetchSupplierContactList()
        {
            recallServices.findSupplierContacts(this.$store.state.orgId).then(resp => {
                if (!resp.error) {
                    this.SupplierContactlst = resp.data.d
                }
            })
        },
        GetKnownSupplierDistributorProfile(id) {
            notiOrgService.GetKnownSupplierProfileForRecall(id).then((res) => {
                if(res.data.d){
                    this.distributorLogo= res.data.d.logo ? 'data:image;base64,' + res.data.d.logo : ''
                }
            })
        },
        getAutoNotifySetting()
        {
            organizationService.getAutoNotifySetting().then(resp => {
                if (!resp.error) {
                    this.autonotifychecked=resp.data.d.isautonotify
                    if(resp.data.d.isautonotify)
                    {
                        this.fetchSupplierContactList()
                    }
                }
            })
        },
        getRecallSummaryById() {
            var providerCommunicationId=this.$route.params.providerCommunicationId==undefined?0:parseInt(this.$route.params.providerCommunicationId)
            recallServices.getRecallSummaryById(this.id,providerCommunicationId.toString()).then(resp => {
                if (resp.error){
                    this.$router.push({ name: 'prov_Recall' })
                } else {
                    this.item = resp.data.d
                    if(this.item.completed_at != null)
                    {
                        this.completedRecall=true
                    }
                    if(this.item.providerEventStatus == 'DRAFT' || this.item.providerEventStatus == 'COMPLETED' || this.item.providerEventStatus == 'CLOSED' || this.item.completed_at != null)
                    {
                        this.disabledDelegate=true
                    }
                    else
                    {
                        this.disabledDelegate=false
                        this.completedRecall=false
                    }
                    this.disabledDelegate=false
                    this.isProviderCreatedRecall=resp.data.d.isProviderCreated
                    this.iscustomisedcontent = resp.data.d.is_customized_content
                    this.communicationType = resp.data.d.communicationType
                    this.labels={
                        details: resp.data.d.communicationType == this.recall ? 'Recall Details' : 'Advisory Details',
                        logs: resp.data.d.communicationType == this.recall ? 'Recall Logs' : 'Advisory Logs',
                    }
                    this.getRecallresponseDetails()
                    this.GetKnownSupplierDistributorProfile(this.item.masterDistributorId)
                }
            })
        },
        onLoad(event){
            this.type = event.toLowerCase()
        },
        onReLoadCommunicationData(){
            this.getRecallSummaryById()
        },
        onReLoadHistoryData(){
            this.GetRecallHistories()
        },
        onReLoad(event){
            this.getRecallresponseDetails()
        },
        getResponseFormData() {
            if(this.communicationType === COMMUNICATION_TYPE.RECALL){
                recallServices.getResponseFormData(this.id, this.providerCommunicationId).then(resp => {
                    this.responseFormData = resp.data.d
                    this.isDrugRecall = this.responseFormData.products.length > 0 && this.responseFormData.products[0].fields.some(field => field.field_name === 'NDC')
                })
            }
        },
        getRecallresponseDetails() {
            recallServices.getRecallresponseDetails(this.id,this.providerCommunicationId).then(resp => {
                this.responseDetails = resp.data.d
            })
        },
        changeStatus () {
            if(this.item.communicationType == COMMUNICATION_TYPE.RECALL){
                this._showConfirm(this.item && this.item.completed_at ? 'Are you sure you want to mark this recall as open?' : 'Are you sure you want to mark this recall as complete?', {title: 'Recall', variant: 'warning'}).then(confirm => {
                    if (confirm) {
                        this.changeRecallStatus()
                    }
                })
            }
            if(this.item.communicationType == COMMUNICATION_TYPE.PRODUCTDISRUPTION){
                this._showConfirm(this.item && this.item.completed_at ? 'Are you sure you want to mark this supply advisory as open?' : 'Are you sure you want to mark this supply advisory as complete?', {title: 'Supply Advisory', variant: 'warning'}).then(confirm => {
                    if (confirm) {
                        this.changeRecallStatus()
                    }
                })
            }
        },
        acknowledge () {
            recallServices.acknowledgeRecall(this.id,this.providerCommunicationId).then(resp =>{
                if (!resp.error){
                    this.getRecallSummaryById()
                    this._showNotify('Acknowledge', this.item.communicationType == COMMUNICATION_TYPE.RECALL ? 'The recall has been acknowledged' :  'The advisory has been acknowledged' , null, {animationIcon: 'success', hideFooter: true, hideHeader: true})
                }
            })
        },
        downloadproviderAffectedLocationReport(extensionType) {
            recallServices.getRecallById(this.id,this.providerCommunicationId).then(resp => {
                if (resp.error) {
                    this.$router.push({ name: 'prov_Recall' })
                } else {
                    var isCentralizedSettingOn = this.$store.state?.organization?.is_centralized_setting_enabled
                    recallServices.downloadproviderAffectedLocationReport(this.id,isCentralizedSettingOn  ? 'EMAILED' :'COVERED',this.$store.state.user.id ? this.$store.state.user.id : -1,extensionType,resp.data.d.communicationUID,this.providerCommunicationId,this.item.recallsitename)
                }
            })
        },
        downloadproviderAffectedProductsReport(extensionType) {
            recallServices.getRecallById(this.id,this.providerCommunicationId).then(resp => {
                if (resp.error) {
                    this.$router.push({ name: 'prov_Recall' })
                } else {
                    recallServices.downloadproviderAffectedProductsReport(this.id,extensionType,resp.data.d.communicationUID,this.providerCommunicationId,this.item.recallsitename)
                }
            })
        },
        downloadCCReport(extensionType) {
            recallServices.getRecallById(this.id,this.providerCommunicationId).then(resp => {
                if (resp.error) {
                    this.$router.push({ name: 'prov_Recall' })
                } else {
                    recallServices.downloadCCReport(this.id,extensionType,resp.data.d.communicationUID,this.providerCommunicationId,this.item.recallsitename)
                }
            })
        },
        addMoreRespClick(item) {
            this.respModalKey += 1
            this.$nextTick(() => {
                this.$refs.recallResponseEmailModal.forceRerenderInsert(item)
            })
        },
        onCompleted(event) {
            if (event) {
                this.responseDetails.responseEmail= this.$refs.responseEmailModal.ccvalueE.pop()
                //this.responseDetails.responseCCEmails= this.$refs.responseEmailModal.ccvalue
                this.responseDetails.additionalCcEmails= this.$refs.responseEmailModal.ccvalue
                this.responseDetails.supplierRepCCEmails= this.$refs.responseEmailModal.defaultEmailList.email
                this.$refs.responseEmailModal.$refs.modal.hide()
                this.$refs.responseEmailModal.response_email=null
                this.$refs.responseEmailModal.filesUpload=[]
                this.responseDetails.supplier_name = this.item.supplier_name
                recallServices.updateRecallResponseEmail(this.id,this.providerCommunicationId, this.responseDetails.responseEmail,event).then(resp=>{
                    if (!resp.error){
                        this.addMoreRespClick( this.responseDetails)
                    }
                })

            }
        },
        goToEditRecall() {
            localStorage.setItem('recallMode', 'EDIT')
            localStorage.removeItem('savedStep')
            localStorage.removeItem('RecallFeedId')
            localStorage.removeItem('RecallFeedSourceId')
            this.$router.push({
                name: router.prov_Recall_EditItem.name,
                params: { id: this.id ,providerCommunicationId: this.providerCommunicationId}
            })
        },
        respondToRecall(){
            this._showConfirm(this.item && this.item.completed_at ? 'Are you sure you want to mark this recall as open?' : 'Are you sure you want to mark this recall as complete?', {title: 'Recall', variant: 'warning'}).then(confirm => {
                if (confirm) {
                    // Check if conditions are met to show RecallResponseModal
                    if (this.item.isProviderCreated &&
                        this.$store.state.userType === 'PROVIDER' &&
                        this.communicationType === 'RECALL' &&
                        this.item.completed_at == null) {
                        // Populate existing files from responseDetails.documents
                        if (this.responseDetails && this.responseDetails.documents) {
                            this.$refs.recallResponseModal.filesUpload = this.responseDetails.documents.map(x => {
                                return {
                                    id: x.id,
                                    file: {
                                        name: x.name,
                                        type: x.type,
                                        size: x.size,
                                        extension: x.extension
                                    },
                                }
                            })
                        }
                        this.$nextTick(() => {
                            this.$refs.recallResponseModal.forceRerenderModel()
                        })
                        return
                    }
                    // Original logic for other cases
                    if ((!this.responseDetails.is_response_document  && this.item.completed_at == null ) || (this.responseDetails.responseEmail === null  && this.item.completed_at == null)) {
                        if (this.responseDetails.responseEmail === null || this.responseDetails.responseEmail === '' || this.responseDetails.documents.length === 0 || this.responseDetails.status === 'BOUNCE') {
                            this.supplierModalKey += 1
                            this.$refs.responseEmailModal.response_email = this.responseDetails.responseEmail
                            this.$refs.responseEmailModal.item.affectedProduct = this.responseDetails.affectedProduct
                            this.$refs.responseEmailModal.item.affectedProductValue = this.responseDetails.affectedProductValue
                            this.$refs.responseEmailModal.filesUpload = this.responseDetails.documents.map(x => {
                                return {
                                    id: x.id,
                                    file: {
                                        name: x.name,
                                        type: x.type,
                                        size: x.size,
                                        extension: x.extension
                                    },
                                }
                            })
                            this.$nextTick(() => {
                                this.$refs.responseEmailModal.forceRerenderModel()
                            })
                        } else {
                            this.$nextTick(() => {
                                this.$refs.responseEmailModal.forceRerenderModel()
                            })
                            //this.addMoreRespClick(this.responseDetails)
                        }
                    }  else{
                        if(this.responseDetails.is_response_document && this.item.completed_at == null  && (this.responseDetails.responseEmail!=null || this.responseDetails.responseEmail != ''))
                        {
                            this.supplierModalKey += 1
                            this.$refs.responseEmailModal.response_email = this.responseDetails.responseEmail
                            this.$refs.responseEmailModal.item.affectedProduct = this.responseDetails.affectedProduct
                            this.$refs.responseEmailModal.item.affectedProductValue = this.responseDetails.affectedProductValue
                            this.$refs.responseEmailModal.filesUpload = this.responseDetails.documents.map(x => {
                                return {
                                    id: x.id,
                                    file: {
                                        name: x.name,
                                        type: x.type,
                                        size: x.size,
                                        extension: x.extension
                                    },
                                }
                            })
                            this.$nextTick(() => {
                                this.$refs.responseEmailModal.forceRerenderModel()
                            })
                            //this.addMoreRespClick(this.responseDetails)
                        }
                        else{
                            this.changeRecallStatus()
                        }
                    }

                }
            })
        },
        onSubmit(event) {
            if(event== 'yes'){
                this.changeRecallStatus()
            } else{
                this.getRecallSummaryById()

                this.$refs.communicationdetails.getRecallById()
            }
        },

        onRecallResponseSubmitted(formData) {
            this.$refs.recallResponseModal.hideModal()
            this.addMoreRespClick(formData)
            // Mark the recall as complete
            //this.changeRecallStatus()
        },
        onMarkRecallComplete(eventData) {
            this.changeRecallStatus()
            //this._showToast('Recall marked as complete without sending email', { variant: 'success' })
        },
        onRefreshRecallData() {
            this._showToast('Recall response submitted successfully', { variant: 'success' })
            this.getResponseFormData()
        },

        changeRecallStatus() {
            recallServices.changeRecallCompleteStatus(this.id,this.providerCommunicationId).then(resp => {
                if (!resp.error) {
                    if(this.item.communicationType == COMMUNICATION_TYPE.RECALL){
                        if (this.item.completed_at == null) {
                            this.disabledDelegate = true
                            this._showToast('Recall has been marked as complete!', { variant: 'success' })
                        } else {
                            this.disabledDelegate = false
                            this._showToast('Recall has been reopened!', { variant: 'success' })
                        }
                    }
                    if(this.item.communicationType == COMMUNICATION_TYPE.PRODUCTDISRUPTION){
                        if (this.item.completed_at == null || this.item.providerEventStatus == 'DRAFT') {
                            this.disabledDelegate = true
                            this._showToast('Supply advisory has been marked as complete!', { variant: 'success' })
                        } else {
                            this.disabledDelegate = false
                            this._showToast('Supply advisory has been reopened!', { variant: 'success' })
                        }
                    }
                    if(this.$refs.communicationdetails != undefined)
                    {
                        this.$refs.communicationdetails.getRecallById()
                    }
                    this.getRecallSummaryById()
                }
            })
        },
        sendNotification() {
            recallServices.sendNotification(this.id, this.communicationType, this.providerCommunicationId).then(resp => {
                if (!resp.error) {
                    this.getRecallSummaryById()
                    this.getCommunicationSummaryById()
                    if (this.tabDetails == true) {
                        this.tabDetailsKey += 1
                    }
                    this._showToast('Notification Sent Successfully!', { variant: 'success' })
                    this.getCommunicationSummaryById()
                    this.$refs.communicationdetails.getRecallById()
                }
            })
        },
        getCommunicationSummaryById() {
            recallServices.getCommunicationSummaryById(this.id).then(resp => {
                if (resp.error){
                    this.$router.push({ name: 'prov_ProdDisruption' })
                } else {
                    this.item = resp.data.d
                    this.unreadMessages = this.item.unreadMessageCount
                    this.dependentDisabledDates.to = this.item.disruptionUpdateDate ? new Date(new Date(this.item.disruptionUpdateDate.split('T')[0]).getFullYear(), new Date(this.item.disruptionUpdateDate.split(' ')[0]).getMonth(), (new Date(this.item.disruptionUpdateDate.split(' ')[0]).getDate())) : new Date(this.item.communicationDate)
                    if(this.item.status == 'CLOSED' || this.item.providerEventStatus == 'DRAFT' || this.item.providerEventStatus == 'COMPLETED')
                    {
                        this.disabledDelegate=true
                    }
                    else
                    {
                        this.disabledDelegate=false
                    }
                }
            })
        },
        getSwitchSitesById(communicationUID, communicationType) {
            recallServices.getSwitchSites(communicationUID, communicationType).then(resp => {
                if (!resp.error){
                    const recallsarray = []
                    for (var i = 0; i < resp.data.d.c.length; i++) {
                        if(resp.data.d.c[i].userSiteName != undefined)
                        {
                            if(resp.data.d.c[i].userSiteName.includes('Corporate'))
                            {
                                resp.data.d.c[i].isEdit = true
                            }
                            else
                            {
                                if(resp.data.d.c[i].recall_sites.includes('Corporate')){
                                    resp.data.d.c[i].isEdit = false
                                }
                                else
                                {
                                    var usrarr = resp.data.d.c[i].userSiteName.split(',')
                                    var rclarr = resp.data.d.c[i].recall_sites.split(',')
                                    if(rclarr.length > usrarr.length)
                                    {
                                        resp.data.d.c[i].isEdit = false
                                    }
                                    else
                                    {
                                        var isEdit = true
                                        for (var p = 0; p < rclarr.length; p++)
                                        {
                                            if(!resp.data.d.c[i].userSiteName.includes(rclarr[p].trimEnd().trimStart()))
                                            {
                                                isEdit = false
                                            }
                                        }
                                        resp.data.d.c[i].isEdit = isEdit
                                    }
                                }
                            }
                        }
                        if(resp.data.d.c[i].classification === 'BLANK')
                        {
                            resp.data.d.c[i].classification = ''
                        }
                        if(resp.data.d.c[i].distributorName === 'undefined')
                        {
                            resp.data.d.c[i].distributorName = null
                        }
                        if(resp.data.d.c[i].affectedProduct === 'undefined' || resp.data.d.c[i].affectedProduct === '')
                        {
                            resp.data.d.c[i].affectedProduct = null
                        }
                        if(resp.data.d.c[i].status === null)
                        {
                            resp.data.d.c[i].status = ''
                        }
                        if(resp.data.d.c[i].responsestatus === 'BOUNCE')
                        {
                            resp.data.d.c[i].responsestatus = 'ERROR'
                        }
                        if(resp.data.d.c[i].responseListingStatus === null)
                        {
                            resp.data.d.c[i].responseListingStatus = ''
                        }
                        const TotalCopyCount=resp.data.d.c.filter(s=>s.communicationId==resp.data.d.c[i].communicationId && s.recallSiteId>0).length
                        resp.data.d.c[i].recallSiteCount=TotalCopyCount
                        var checkexist=recallsarray.filter(s=>s.communicationId==resp.data.d.c[i].communicationId)
                        if (checkexist.length==0) {
                            const CompletedCount=resp.data.d.c.filter(s=>s.communicationId==resp.data.d.c[i].communicationId && s.recallSiteId>0 && s.status_provider=='COMPLETED').length
                            if(TotalCopyCount !=0 && TotalCopyCount!=CompletedCount)
                            {
                                resp.data.d.c[i].status_provider='NOT COMPLETED'
                            }
                            if(TotalCopyCount !=0 && TotalCopyCount==CompletedCount){
                                resp.data.d.c[i].status_provider='COMPLETED'
                            }

                            recallsarray.push(resp.data.d.c[i])
                        }
                    }
                    this.switchSites = resp.data.d.c
                    this.switchSitesTotal = resp.data.d.c.length
                    this.title = { type: 'Recall'}
                    this.$root.$emit('bv::show::modal', 'modal-xl-switch', 'RECALL')
                }
            })
        },
        viewChildRecall(item)
        {
            this.$router.push({
                name: item.communicationType == COMMUNICATION_TYPE.RECALL ?  'prov_RecallView' : 'prov_DisruptionView',
                params: { id: item.communicationId ,providerCommunicationId: item.providerCommunicationId,recallSiteCount: item.recallSiteCount, switchSites: this.ChildRecall,communicationType: item.communicationType},
            })
        },
        viewRecall(item) {
            this.getSwitchSitesById(item.id, item.communicationType)
        },
        // Toast queue management methods
        _showToast(message, options = {}) {
            const toastData = {
                message,
                options: {
                    variant: options.variant || 'success',
                    autoHideDelay: options.autoHideDelay || 3000,
                    toaster: 'b-toaster-top-center',
                    solid: true,
                    appendToast: false,
                    ...options
                }
            }
            this.toastQueue.push(toastData)
            if (!this.isToastActive) {
                this.processToastQueue()
            }
        },
        processToastQueue() {
            if (this.toastQueue.length === 0 || this.isToastActive) {
                return
            }
            const toastData = this.toastQueue.shift()
            this.isToastActive = true
            if (this.toastTimeout) {
                clearTimeout(this.toastTimeout)
            }
            this.$bvToast.hide()
            this.$bvToast.toast(toastData.message, toastData.options)
            this.toastTimeout = setTimeout(() => {
                this.isToastActive = false
                this.toastTimeout = null
                this.processToastQueue()
            }, toastData.options.autoHideDelay)
        },
        clearToastQueue() {
            this.toastQueue = []
            if (this.toastTimeout) {
                clearTimeout(this.toastTimeout)
                this.toastTimeout = null
            }
            this.isToastActive = false
            this.$bvToast.hide()
        },
    }
}